import { Component, Input, OnInit } from '@angular/core';
import { OfferNumberContext, OfferNumberService } from '../../../../../services/offer-number.service';

@Component({
  selector: 'app-send-offer-number',
  templateUrl: './send-offer-number.component.html',
  styleUrls: ['./send-offer-number.component.scss']
})
export class SendOfferNumberComponent implements OnInit {

  @Input() context: OfferNumberContext;

  constructor(public offerNumberService: OfferNumberService) {
  }

  ngOnInit() {
  }

  get quotationId(): string {
    return this.offerNumberService.getQuotationId();
  }

  get offerNumber(): string {
    return this.offerNumberService.getOfferNumber(this.context);
  }
}
